<div id="threejs-container">
    <div class="radial-gradient"></div>
</div>
